<input
    #timerInput
    class="form-control form-control-sm timer-input text-end"
    type="text"
    (change)="onChangeTimer(timerInput.value)"
    [value]="timer | time"
    [disabled]="disabled"
/>
